var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.0417V3.29167C1 2.68388 1.24144 2.10098 1.67121 1.67121C2.10098 1.24144 2.68388 1 3.29167 1H14.75C14.9931 1 15.2263 1.09658 15.3982 1.26849C15.5701 1.44039 15.6667 1.67355 15.6667 1.91667V18.4167C15.6667 18.6598 15.5701 18.8929 15.3982 19.0648C15.2263 19.2368 14.9931 19.3333 14.75 19.3333H3.29167C2.68388 19.3333 2.10098 19.0919 1.67121 18.6621C1.24144 18.2323 1 17.6495 1 17.0417ZM1 17.0417C1 16.4339 1.24144 15.851 1.67121 15.4212C2.10098 14.9914 2.68388 14.75 3.29167 14.75H15.6667M4.66667 9.25H12M4.66667 5.58333H10.1667",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderBookIcon);
export default __webpack_public_path__ + "static/media/OrderBookIcon.45cf16925a014798565476a979d223ad.svg";
export { ForwardRef as ReactComponent };